import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as ContactsActions from "@Actions/contacts.actions";
import { AppState } from "@State/app.state";
import { Store } from "@ngrx/store";
import { ContactsService } from "@Services/contacts.service";
import { catchError, combineLatest, concat, delay, filter, mergeMap, of, tap, withLatestFrom } from "rxjs";

@Injectable()
export class ContactsEffects {

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private contactSvc: ContactsService
  ){}

  /**
   * Load user contacts only when the contacts are empty and strictly
   * after user infos are loaded (to prevent sending requests without token)
   */
  loadContacts$ = createEffect(() =>
    combineLatest([
      this.actions$.pipe(ofType(ContactsActions.loadContacts)),
      this.store.select((state) => state.userContacts),
      this.store.select((state) => state.user.infoLoaded)
    ])
    .pipe(
      filter(([_action, contactsState, userInfoLoaded]) => {
        return userInfoLoaded && contactsState.contacts.length === 0 && !contactsState.doneLoading;
      }),
      mergeMap(([action]) => {
        const { delayTime } = action;
        return this.contactSvc.getUserContacts()
          .pipe(
            delay(delayTime),
            mergeMap((contactRes) =>
              concat(
                of(ContactsActions.contactsDoneLoading()),
                of(ContactsActions.setContacts({ contacts: contactRes.contacts })),
              )
            ),
            catchError((_error) =>
              concat(
                of(ContactsActions.contactsDoneLoading()),
                of(ContactsActions.contactsLoadError()),
              )
            )
          )
      })
    )
  )


}
